export const removePageFromUrl = (url: string) => {
  // Use a regular expression to remove any '/page/:id' part from the URL
  return url.replace(/\/page\/\d+/, "")
}

export const removeParamsAndAnchors = (url: string) => {
  return url.replace(/\?.*|#.*/g, "")
}